import { WeightUnit } from '@freight-cbm/shared-types';
import { useAppStore } from '@/store/store';
import { PACKAGE_TEMPLATES } from '@freight-cbm/shared-logic';

export function TemplatePicker() {
  const addPackage = useAppStore((s) => s.addPackage);
  const clearAll = useAppStore((s) => s.clearPackages);
  const preferences = useAppStore((s) => s.preferences);

  const handleTemplate = (templateIndex: number) => {
    const template = PACKAGE_TEMPLATES[templateIndex];
    if (!template) return;
    const packages = useAppStore.getState().packages;
    if (packages.length > 0 && !confirm('This will replace all current packages. Continue?')) return;
    clearAll();
    addPackage({
      length: template.length,
      width: template.width,
      height: template.height,
      dimUnit: template.dimUnit,
      weight: 0,
      weightUnit: preferences.defaultWeightUnit ?? WeightUnit.Kg,
      quantity: 1,
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: 'var(--space-2)',
        flexWrap: 'wrap',
        alignItems: 'center',
      }}
    >
      <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>
        Templates:
      </span>
      {PACKAGE_TEMPLATES.map((t, i) => (
        <button
          type="button"
          key={t.name}
          className="btn btn-sm"
          onClick={() => handleTemplate(i)}
          title={`${t.name}: ${t.length}×${t.width}×${t.height} ${t.dimUnit}`}
        >
          {t.name}
        </button>
      ))}
    </div>
  );
}
